export default __webpack_public_path__ + "static/midea3-27edbfb6f53d0dd3e1b88776a917b197.jpg";